<template>

	<div style="width: 100%;">
		<!-- 原始的<LD ref="workPermit" v-if="currentType === 3" :initUserData="userData" :areaData="areaData" :operaDataCache="operaDataCache"
		 :workerSelect="workerSelect" :applicantSelect="applicantSelect" :permitType="type"></LD> 
		修改了type改成currentType  :permitType="type"改成:permitType="currentType"
		-->
    <!-- 临时用电 -->
		<LD ref="workPermit" v-if="workPermitType.id === 3 && type === 1" :initUserData="userData" :areaData="areaData" :operaDataCache="operaDataCache"
		 :workerSelect="workerSelect" :applicantSelect="applicantSelect" :workPermitType="workPermitType" :departmentSelect="departmentSelect"></LD>
    <!-- 动火 -->
		<DH ref="workPermit" v-if="workPermitType.id === 4 && type === 1" :initUserData="userData" :areaData="areaData" :operaDataCache="operaDataCache"
        :workerSelect="workerSelect" :applicantSelect="applicantSelect" :departmentSelect="departmentSelect"></DH>
    <!-- 受限空间 -->
		<SJ ref="workPermit" v-if="workPermitType.id === 7 && type === 1" :initUserData="userData" :areaData="areaData" :operaDataCache="operaDataCache"
		 :workerSelect="workerSelect" :applicantSelect="applicantSelect" :workPermitType="workPermitType" :departmentSelect="departmentSelect"></SJ>
    <!-- 盲板抽堵 -->
		<CD ref="workPermit" v-if="workPermitType.id === 8 && type === 1" :initUserData="userData" :areaData="areaData" :operaDataCache="operaDataCache"
		 :workerSelect="workerSelect" :applicantSelect="applicantSelect" :workPermitType="workPermitType" :departmentSelect="departmentSelect"></CD>
    <!-- 高处作业 -->
		<GA ref="workPermit" v-if="workPermitType.id === 9 && type === 1" :initUserData="userData" :areaData="areaData" :operaDataCache="operaDataCache"
		 :workerSelect="workerSelect" :applicantSelect="applicantSelect" :workPermitType="workPermitType" :departmentSelect="departmentSelect"></GA>
    <!-- 吊装安全 -->
		<DZ ref="workPermit" v-if="workPermitType.id === 10 && type === 1" :initUserData="userData" :areaData="areaData" :operaDataCache="operaDataCache"
		 :workerSelect="workerSelect" :applicantSelect="applicantSelect" :workPermitType="workPermitType" :departmentSelect="departmentSelect"></DZ>
    <!-- 动土 -->

		<DT ref="workPermit" v-if="workPermitType.id === 12 && type === 1" :initUserData="userData" :areaData="areaData" :operaDataCache="operaDataCache"
		 :workerSelect="workerSelect" :applicantSelect="applicantSelect" :workPermitType="workPermitType" :departmentSelect="departmentSelect"></DT>
    <!-- 断路 -->
		<DL ref="workPermit" v-if="workPermitType.id === 11 && type === 1" :initUserData="userData" :areaData="areaData" :operaDataCache="operaDataCache"
		 :workerSelect="workerSelect" :applicantSelect="applicantSelect" :workPermitType="workPermitType" :departmentSelect="departmentSelect"></DL>
    <!-- 检修安全作业   -->
    <JX ref="workPermit" v-if="workPermitType.id === 13 && type === 1" :initUserData="userData" :areaData="areaData" :operaDataCache="operaDataCache"
        :workerSelect="workerSelect" :applicantSelect="applicantSelect" :workPermitType="workPermitType" :departmentSelect="departmentSelect"></JX>
	</div>

</template>

<script>
	import DH from './ProcessWorkPermitDH.vue';
	import LD from './ProcessWorkPermitLD.vue';
	import SJ from './ProcessWorkPermitSJ.vue';
	import CD from './ProcessWorkPermitCD.vue';
	import GA from './ProcessWorkPermitGA.vue';
	import DZ from './ProcessWorkPermitDZ.vue';
	import DT from './ProcessWorkPermitDT.vue';
  import DL from './ProcessWorkPermitDL.vue';
  import JX from './ProcessWorkPermitDL.vue';
  import { getWorkerSelect, getApplicantSelect } from "@/api/processManager"
  import { getAllDepartment } from "@/api/processManager"
	export default {
		props: {
			type: Number,
			userData: Object,
			areaData: Object,
			operaDataCache: Object,
			workPermitType: Object
		},
		name: 'processWorkPermitChoose',
		components: {
			LD,
			DH,
			SJ,
			CD,
			GA,
			DZ,
			DT,
			DL,
      JX
    },
    data() {
      return {
        workerSelect: [], // 作业人的下拉数据
        applicantSelect: [], // 申请单位的下拉数据
        departmentSelect: [],//申请部门的下拉数据
      }
    },
		methods: {
			returnCacheData() {
				return this.$refs.workPermit.returnCacheData();
			},
			dataBackfill(data) {
				this.$refs.workPermit.dataBackfill(data);
			}
    },
    created() {
      //Todo: 获取有作业证用户
      getWorkerSelect().then(res => {
        let arr = res.body.data
        for(let i in arr) {
          this.workerSelect.push(arr[i])
        }
      })
      getApplicantSelect().then(res => {
        this.applicantSelect = []
        this.applicantSelect.push({ id: 0, contrName: "本企业" },...res.body.data)
      })
      getAllDepartment().then(res => {
        this.departmentSelect = []
        this.departmentSelect.push(...res.body.data)
      })
    }
  }
</script>

<style>
</style>
